import project_one from "../Assets/images/ourwork/rk construction one.jpeg";
import project_two from "../Assets/images/ourwork/rk construction two.jpeg";
import project_three from "../Assets/images/ourwork/rk construction three.jpeg";
import project_four from "../Assets/images/ourwork/rk construction four.jpeg";
import project_five from "../Assets/images/ourwork/rk construction five.jpeg";
import project_six from "../Assets/images/ourwork/rk construction six.jpeg";

// related images (example)
// import p1_2 from "../assets/projects/p1_2.jpg";
// import p1_3 from "../assets/projects/p1_3.jpg";

const projectsData = [
  {
    title: "Modern Residential Villa",
    category: "Residential",
    coverImage: project_one,
    img: project_one,
    images: [project_one],
  },
  {
    title: "Commercial Complex",
    category: "Commercial",
    coverImage: project_two,
    img: project_two,
    images: [project_two],
  },
  {
    title: "Luxury Apartment",
    category: "Residential",
    coverImage: project_three,
    img: project_three,
    images: [project_three],
  },
  {
    title: "Office Building",
    category: "Commercial",
    coverImage: project_four,
    img: project_four,
    images: [project_four],
  },
  {
    title: "Family Home",
    category: "Residential",
    coverImage: project_five,
    img: project_five,
    images: [project_five],
  },
  {
    title: "Industrial Warehouse",
    category: "Industrial",
    coverImage: project_six,
    img: project_six,
    images: [project_six],
  },
];

export default projectsData;
